import { render, staticRenderFns } from "./MyOrderInfo.vue?vue&type=template&id=845ea836&scoped=true&"
import script from "./MyOrderInfo.vue?vue&type=script&lang=js&"
export * from "./MyOrderInfo.vue?vue&type=script&lang=js&"
import style0 from "./MyOrderInfo.vue?vue&type=style&index=0&id=845ea836&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "845ea836",
  null
  
)

export default component.exports